import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function DeOrdeVanHetVliegendeZwaard() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>De Orde van het Vliegende Zwaard</h1>
          <InlineImage image="dnd/LogoVliegendeZwaard.png" border={false} width={175} subscript="Logo orde van het Vliegende Zwaard" />
          <p>
            In de D&D campaign Carpéthia spelen we al geruime tijd met avonturiers die lid zijn van "De Orde van het Vliegende Zwaard". Maar wat is nu eigenlijk de oorsprong van
            deze orde? Daarover tasten de avonturiers vooralsnog in het duister. In 'real life' bestond de Orde al in de tijd dat ik niet D&D maar GURPS speelde. Er was gewoonweg
            een reden nodig om een groep avonturiers samen op pad te laten gaan, en er moest iets zijn dat de groep een beetje bij elkaar hield. Door te eisen dat iedereen lid was
            van en loyaal was aan de Orde werd dit bereikt. Maar dat wil natuurlijk niet zeggen dat de groep zich toen ook al gedroeg als een stelletje losgeslagen idioten.
          </p>
          <h2>De Orde in het GURPS-tijdperk</h2>
          <p>
            In het GURPS tijdperk is een achtergrond van de orde bedacht. In de D&D campaign is echter een andere achtergrond gehanteerd. Ter lering ende vermaeck is hieronder echt
            de achtergrond van de orde uit het GURPS tijdperk vermeld.
          </p>
          <h3>Achtergrond van de orde</h3>
          <p>
            Wanneer, door wie en wanneer de orde van het vliegende zwaard is opgericht is bij geen van de leden bekend. Wel is het doel van de orde bekend, deze prijkt boven het
            gebouw van de orde; "Zelfverzekerd doch behoedzaam is hij die het heeft gezien en beleefd. Onzeker en bedreigd is hij die het wil bezien en zich zo met angst omgeeft".
            Ofwel de orde houdt zich bezig met de "ontdekking" van de wereld (een soort NASA zeg maar). En dat er nog een hele hoop te ontdekken valt, daar is geen twijfel over
            mogelijk. De Drakondrin familie heeft zich namelijk altijd openlijk verzet tegen de orde. Sterker nog, de orde was tot voor kort verboden en je kon opgesloten worden in
            de kerkers van het kasteel wanneer bekend werd dat je lid was van de orde. De orde bestaat inmiddels uit een man of 200. De leider van de orde is Fluit. Fluit is een
            nogal warrige oude maar zeer wijze magier. Hij deelt de avonturiers groepen in en verzamelt de informatie en goederen die de groepen verzamelen. Iedere groep krijgt
            betaalt voor iedere opdracht die ze succesvol vervullen. Ieder lid heeft recht op het volgende; 1500 zilverstukken startkapitaal op een "rekening" bij Zilverstort, de
            lokale bank. Gratis eten en overnachting in een bij de stad aangesloten herberg. Hulpmateriaal zoals paarden in overleg te leen.
          </p>
          <h3>Het ontstaan van de orde</h3>
          <p>
            "Vroeger, lang lang geleden, bestond het vliegende zwaard nog. Het werd gesmeed door Zandor de Kleine, een kleine gnoom die veel goeds voor de wereld heeft gedaan. In
            die tijd waren overvallen en berovingen aan de orde van de dag, en Zandor wilde de vaak hulpeloze slachtoffers helpen. Daarom smeedde hij het Vliegende Zwaard. Dit
            zwaard vloog letterlijk op ieder moment naar de dichstbijzijnde goede geest die hulp nodig had in een gevecht. Het zwaard was een behoorlijk sterk zwaard en zo konden
            veel slachtoffers zich nog net op tijd met succes verdedigen. De smidse van Zandor is nog intact en bevindt zich net buiten Fahrad, op de weg naar Folker-stad.Hij
            bevond zich in het dorp van de Centaurs. Vandaar de ‘Z’ op de muur. De Z van Zandor."
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h2>De Orde in het D&D-tijdperk</h2>
          <p>
            Maar terug in Carpéthia tasten de avonturiers inmiddels in het duister over de ware reden van bestaan van deze orde. Is deze orde echt wel goed? Of heeft Fluit hele
            andere plannen. De volgende informatie hebben ze namelijk inmiddels vernomen;
          </p>
          <p>
            <i>
              Gladius Volantis was een draak die leefde in het land Thousand Kingdoms. Hij groeide al snel uit tot een ware horror voor het land, en terroriseerde de regio door
              plunderingen, ontvoeringen, afslachtingen, enz. Het begon als wraak voor de dood op zijn vader, die door een groep boeren uit de regio werd gedood. Maar al snelde
              wilde hij meer, en de regio naar zijn hand zetten.
            </i>
          </p>
          <p>
            <i>
              Daarvoor sloot hij een pact met een demon. Daarbij kwam zijn ziel onder volledige controle te staan van die demon. Daarvoor in de plaats werd hij onsterfelijk en werd
              hij uitermate sterk. Destijds was hij daardoor praktisch onoverwinnelijk.
            </i>
          </p>
          <p>
            <i>
              Er werd een profetie uitgesproken door het Orakel van Filiabad; geen enkele sterveling zou Gladius Volantis kunnen verslaan. Maar een dappere avonturier, gewapend met
              een magisch onzichtbaar schild, waagde een poging. Toen zij bij Gladius kwam, twijfelde Gladius geen moment. Dit was immers duidelijk een sterveling, dus er kon niets
              gebeuren. Hij spuwde zijn vuur richting de avonturier. Deze hief haar schild, waardoor de vuurzee afketste en het hart van Gladius raakte. Zo kwam het dat Gladius
              verslagen werd. Niet door een sterveling, maar door zichzelf, de onsterfelijke.
            </i>
          </p>
          <p>
            <i>
              Toen Gladius verslagen werd, werd hij met gigantische magische ketens en een magisch masker (muilkorf) door vele magiërs, dwergen, avonturiers en anderen1000 meter
              onder de grond begraven. Daarmee kon de demon zijn ziel niet langer volledig controleren.
            </i>
          </p>
          <p>
            <i>
              De volgelingen van Gladius werden geleid door een hogepriesteres genaamd Strix (wat draaks is voor "Uil"). Jaren later ging ze op zoek naar de locatie waar Gladius
              begraven was, en ontdekte de berg waaronder dat zou moeten zijn. Ze stichtte een dorp bovenop die berg genaamd Owl's nest, samen met haar zoon Aulos (dat zich
              vertaald naar Fluit in het Infernal). Aulos richtte vervolgens “de orde van het Vliegende Zwaard” op, met als doel om Gladius op te graven en te bevrijden. Het is
              onduidelijk of deze Aulos dezelfde persoon is als de huidige leider van de orde met dezelfde naam.
            </i>
          </p>
          <p>
            <i>
              Fluit pretendeert dat de Orde van het Vliegende Zwaard slechts het goede dient, en dat de queestes die onder zijn bewind worden gevoerd slechts dienen om de wereld
              een stukje beter te maken. Het huis van het verborgen schild (genoemd naar het schild uit de legende) geloofd daar natuurlijk geen snars van. Het doel van de orde is
              al die tijd nooit veranderd. Overigens weten alleen avonturiers hoger in rang binnen de orde van het ware doel van de orde, lager geplaatste leden zijn onwetend en
              zijn er inderdaad van overtuigd dat zij slechts het goede dienen. Maar de magische artefacten die door hun worden verzameld moeten ze inleveren bij de orde, die daar
              uiteindelijk de draak mee wil bevrijden.
            </i>
          </p>
        </div>
      </div>
      <div className="box light">
        <div className="row">
          <h1>Karakters</h1>
          <p>
            Door terug te zoeken in de krochten van het archief valt een deel van de leden van de orde te reconstrueren:
            <ul>
              <li>Elania (Elf)</li>
              <li>Reusel von Dreusel (Reus)</li>
              <li>C'Ne Dra Xsar (Dark Elf)</li>
              <li>Émondruël (Mens)</li>
              <li>Flurp Burp (Dwerg)</li>
              <li>Knurf de Bouwer (Dwerg)</li>
              <li>Wannonzordis (mens)</li>
              <li>Flarijn deMorieux (Elf)</li>
              <li>Ghnuffin de Muffin (Mens)</li>
              <li>Larissa (Elf)</li>
              <li>Mø / Kobus (Kobold)</li>
              <li>Warnar (Barbed Devil)</li>
              <li>Innos Zerthimon (Githzerai)</li>
              <li>Samora 'o fin 'a aughdrith alias Iowar (Gaur'Gwaith)</li>
              <li>Bassie</li>
              <li>Firest </li>
              <li>Zesblad (al snel verbasterd tot 'sexblad')</li>
              <li>DrHead </li>
              <li>Korlin </li>
              <li>Fjaknel </li>
              <li>Imawu </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
}

export default DeOrdeVanHetVliegendeZwaard;
